module.exports = __webpack_public_path__ + "static/media/framekep.72a4a662.jpg";